import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const isDev = config.public.env !== 'production'

  if (!config.public.sentryDsn || isDev) {
    return
  }

  const router = useRouter()

  Sentry.init({
    app: nuxtApp.vueApp,
    debug: isDev,
    dsn: config.public.sentryDsn,
    environment: config.public.sentryEnv,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      })
    ],
    tracesSampleRate: Number(config.public.sentrySampleRate)
  })

  return {
    provide: {
      sentrySetContext: Sentry.setContext,
      sentrySetUser: Sentry.setUser,
      sentrySetTag: Sentry.setTag,
      sentryAddBreadcrumb: Sentry.addBreadcrumb,
      sentryCaptureException: Sentry.captureException
    }
  }
})
